/* eslint-disable no-param-reassign */
import axios from 'axios';
import { configure } from 'axios-hooks';
import { authProvider } from '../components/Login/auth/auth_provider';

// Variables de .env cuyos endpoints no requieren Authorization (prod usa -public, local no).
const PUBLIC_API_ENV_KEYS = [
  'REACT_APP_CATALOGS_URL',
  'REACT_APP_PRODUCTS_URL',
  'REACT_APP_PARAMETERS_URL',
  'REACT_APP_QUOTE_URL',
  'REACT_APP_GENERATE_PDF_URL',
  'REACT_APP_SEND_EMAIL_URL',
  'REACT_APP_PAYMENT_INFO',
  'REACT_APP_PAYMENT_SESSION_UPDATE_TOKEN',
  'REACT_APP_SEND_TOKEN_UPDATE_URL',
  'REACT_APP_SEND_TOKEN_UPDATE_PAYPHONE_URL',
];

const PUBLIC_API_URLS = PUBLIC_API_ENV_KEYS
  .map((key) => process.env[key])
  .filter(Boolean);

const getUrlPath = (url = '') => url.split('?')[0];

const isPublicEndpoint = (url = '') => {
  const path = getUrlPath(url);
  if (path.endsWith('-public')) {
    return true;
  }
  return PUBLIC_API_URLS.some((publicUrl) => getUrlPath(publicUrl) === path);
};

const getJwtIdToken = () => {
  try {
    const applicationState = JSON.parse(sessionStorage.getItem('persist:applicationState'));
    const login = applicationState ? JSON.parse(applicationState?.login) : {};
    return login?.response?.jwtIdToken || authProvider.getAccountInfo()?.jwtIdToken;
  } catch {
    return authProvider.getAccountInfo()?.jwtIdToken;
  }
};

/**
 * Global Configurations for Axios, setting BaseURL, Timeout
 * and Interceptors.
 * */
const api = axios.create({
  timeout: 120000,
});

api.interceptors.request.use((config) => {
  config.headers['Ocp-Apim-Subscription-Key'] = `${process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY}`;
  if (!isPublicEndpoint(config.url)) {
    const jwtIdToken = getJwtIdToken();
    if (jwtIdToken) {
      config.headers.Authorization = `Bearer ${jwtIdToken}`;
    }
  }
  return config;
}, (error) => {
  console.log('Catched Request Error:', error);
  return Promise.reject(error);
});

api.interceptors.response.use((response) => {
  return response;
}, (error) => {
  // Do something with response error
  if (error.response?.status === 503) {
    const response = JSON.parse(error.response.data.Message);
    window.location.replace(`/maintenance-window?start=${response.Start}&end=${response.End}`);
  }
  return Promise.reject(error);
});

configure({ axios: api, cache: false });

export default api;
